import store from "../store/index.js";

export const getUserPic = () => {
  return !!store.state.user.user_pic.length
    ? this.$store.state.user.user_pic
    : require("../assets/thumbnails/u-thumbnail.svg");
};
